import { render } from "./ProductCombinations.vue?vue&type=template&id=3994ec8c"
import script from "./ProductCombinations.vue?vue&type=script&lang=js"
export * from "./ProductCombinations.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/brekz-prestashop/brekz-prestashop/web/themes/brekz-2017/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__